module.exports = __webpack_public_path__ + "media/images/emblems/Mattstetten-coat_of_arms-4f0e75edc749fc831ad4402186ddb675.svg";